export const productHierarchyQueryParam = {
  TREND: 'trendId',
  PURCHASING_GROUP: 'purchasingGroupId',
  COMMODITY_GROUP: 'commodityGroupId',
  CATEGORY: 'categoryId',
  SUBCATEGORY: 'subcategoryId'
} as const
